import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import LocalStorage from 'libs/LocalStorage';
import { getAsyncInjectors } from 'helpers/asyncInjectors';
import { serializeQuery } from 'helpers/urlTools';
import App from 'modules/App';
import Account from 'modules/Account';
import { LogoMobileLayout, MobileLoaderLayout } from 'modules/Layout';
import Setup from 'modules/Setup';
import Mobile, { AccountSetup } from 'modules/Mobile';
import { loggedInGuard } from '../guards';
import { getLoader } from '../helpers';
async function action(context) {
    const { route, store, query, getUrl, externalRedirect } = context;
    const Loader = getLoader(store);
    let Component = /*#__PURE__*/ _jsx(Loader, {});
    let redirect;
    if (process.env.BROWSER) {
        redirect = await loggedInGuard(context);
        if (redirect) return {
            redirect
        };
        const { injectSagas, injectReducer } = getAsyncInjectors(store);
        injectSagas(Setup.constants.MODULE_ID, Setup.sagas);
        injectReducer(Mobile.constants.MODULE_ID, Mobile.reducer);
        injectSagas(Mobile.constants.MODULE_ID, Mobile.sagas);
        const state = store.getState();
        const isClientInitialized = App.selectors.isClientInitialized(state);
        if (!isClientInitialized) {
            let returnPathname = getUrl(route.name);
            if (query) returnPathname += `?${serializeQuery(query)}`;
            returnPathname = encodeURIComponent(returnPathname);
            redirect = !isClientInitialized ? `${getUrl('auth')}${returnPathname && `?returnPathname=${returnPathname}`}` : null;
            Component = /*#__PURE__*/ _jsx(MobileLoaderLayout, {});
        } else {
            const mobileSetupExternalReturnUrl = LocalStorage.getItem('mobileSetupExternalReturnUrl');
            const decodedMobileSetupExternalUrl = mobileSetupExternalReturnUrl && decodeURIComponent(mobileSetupExternalReturnUrl);
            LocalStorage.removeItem('mobileSetupExternalReturnUrl');
            const patientProfile = Account.selectors.patientProfile(state);
            if (patientProfile && patientProfile.encryptedExchangeToken) {
                if (decodedMobileSetupExternalUrl) {
                    externalRedirect(decodedMobileSetupExternalUrl);
                } else {
                    store.dispatch(App.actions.goToAid('mobile/host', null));
                }
                Component = /*#__PURE__*/ _jsx(MobileLoaderLayout, {});
            } else {
                Component = /*#__PURE__*/ _jsx(LogoMobileLayout, {
                    children: /*#__PURE__*/ _jsx(AccountSetup, {
                        externalReturnUrl: mobileSetupExternalReturnUrl,
                        isCentralStorageFixed: true
                    })
                });
            }
        }
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        redirect,
        component: Component
    };
}
export default action;
